<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Campo de búsqueda mejorado con autocompletado -->
  <div class="row mb-3">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search by client/email"
          [(ngModel)]="searchText"
          (ngModelChange)="filterInfo()"
          list="sugerenciasConductores"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent"
          ><i class="fas fa-search text-dark"></i
        ></span>
        <datalist id="sugerenciasConductores">
          <option
            *ngFor="let sugerencia of sugerenciasBusqueda"
            [value]="sugerencia"
          ></option>
        </datalist>
      </div>
    </div>
  </div>
  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>#</th>
              <th>Date/Time</th>
              <th>City</th>
              <th>Issue</th>
              <th>IA</th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr *ngFor="let item of filteredData"> -->
            <tr></tr>
            <tr>
              <td>
                <a
                  [routerLink]="['/hub/wpbot/edit']"
                  class="btn btn-link btn-sm p-2 a--personnel"
                >
                  1</a
                >
              </td>
              <td>23/07/2025 18h</td>
              <td>Bogotá</td>
              <td>Pago</td>
              <td>Res</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <div class="col-md-6">
          <button
            class="btn btn-dark btn-sm btn-initial"
            (click)="prevPage()"
            [disabled]="currentPage === 1"
          >
            <
          </button>
          <label>&nbsp;&nbsp;{{ currentPage }}&nbsp;&nbsp;</label>
          <button
            class="btn btn-dark btn-sm btn-initial"
            (click)="nextPage()"
            [disabled]="!morePages"
          >
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
